import React from 'react'
import { useAtomValue } from 'jotai/utils'

import { Entry, gridStateAtomFamily } from './LKGridInstance/components/atoms/gridStateFamilyAtom'

interface ComponentProps {
  gridIdentity?: string
}

interface WithGridStateProps {
  gridState: Entry
}

export const withGridState =
  (getIdentity?: (props: Object) => string) =>
  <P extends ComponentProps>(Component: React.ComponentType<P & WithGridStateProps>): React.FC<P> =>
  (props) => {
    const id = getIdentity ? getIdentity(props) : props.gridIdentity

    const gridState = useAtomValue(gridStateAtomFamily(id))

    return <Component {...props} gridState={gridState} />
  }
